<template>
  <div ref="signUpForm" class="sign_up">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" class="d-flex justify-center">
          <v-card max-width="800" width="800" class="pa-8">
            <h3 class="text-secondary fancy xxl">Enjoy...</h3>

            <div class="ml-5 text-secondary mb-4">Greater passion.</div>

            <div class="ml-10 text-secondary mb-4">Unique role-play dates.</div>

            <div class="ml-15 text-secondary">Deeper connection and intimacy.</div>

            <div class="mt-10">
              <span class="text-secondary md font-weight-bold"> Faithful Fling </span>
              is the only membership website devoted to providing you and your spouse with sexy
              role-play dates designed to keep the passion and desire alive!
            </div>

            <div class="mt-10 mb-10">
              <div class="text-secondary md font-weight-bold">
                With your subscription, you'll enjoy:
              </div>

              <ul class="ml-5">
                <li>a single membership shared with your spouse</li>
                <li>two separate usernames and passwords</li>
                <li>access to your FREE Fling “The Test Drive”</li>
                <li>access to our expansive library of Fling Teasers</li>
                <li>more flirting</li>
                <li>more foreplay</li>
                <li>more sex... and even better sex!</li>
                <li>more fantasy</li>
              </ul>
            </div>

            <div class="mt-10 mb-10">
              <div class="text-secondary md font-weight-bold">Start your FREE 21-Day Trial:</div>

              <div>
                Rest assured, you'll have a generous 21-Day Trial period to explore all that
                Faithful Fling has to offer. If you love it like we hope you do, your paid
                membership will seamlessly begin, with the flexibility to cancel anytime. If it's
                not your cup of tea, simply cancel before the FREE 21-Day Trial ends, and you won't
                be charged. Have questions? Reach out to us at
                <a href="mailto:info@faithfulfling.com"> info@faithfulfling.com </a>.
              </div>
            </div>

            <h3 class="text-secondary lg">Sign Up</h3>

            <v-alert
              v-if="errors.non_field_errors"
              dense
              border="left"
              type="warning"
              class="js-form-error"
            >
              {{ errors.non_field_errors[0] }}
            </v-alert>

            <v-form v-model="valid">
              <v-text-field
                label="First name"
                v-model="formFields.first_name"
                :rules="firstNameRules"
                :error-messages="errors.first_name"
                required
              />

              <v-text-field
                label="Last name"
                v-model="formFields.last_name"
                :rules="lastNameRules"
                :error-messages="errors.last_name"
                required
              />

              <v-text-field
                label="Email"
                v-model="formFields.email"
                :rules="emailRules"
                :error-messages="errors.email"
                required
              />

              <v-radio-group v-model="formFields.role" :rules="roleRules" required>
                <v-radio label="I am the husband" value="husband" />
                <v-radio label="I am the wife" value="wife" />
              </v-radio-group>

              <v-expand-transition>
                <div v-show="formFields.role !== ''">
                  <h3 class="text-secondary lg mt-3">{{ spouseTitle }} Information</h3>

                  <v-text-field
                    label="First name"
                    v-model="formFields.spouse_first_name"
                    :rules="firstNameRules"
                    :error-messages="errors.spouse_first_name"
                    required
                  />

                  <v-text-field
                    label="Last name"
                    v-model="formFields.spouse_last_name"
                    :rules="lastNameRules"
                    :error-messages="errors.spouse_last_name"
                    required
                  />

                  <v-text-field
                    label="Email"
                    v-model="formFields.spouse_email"
                    :rules="spouseEmailRules"
                    :error-messages="errors.spouse_email"
                    required
                  />
                </div>
              </v-expand-transition>

              <h3 class="text-secondary lg mt-5">Fling Bundles</h3>

              <v-row>
                <v-col
                  v-for="bundle in activePackages"
                  :key="`bundle-${bundle.id}`"
                  cols="12"
                  :sm="bundle.tokens_per_payment === 12 ? 12 : 6"
                >
                  <v-card
                    class="pa-5 fill-height package-card"
                    @click="formFields.package = bundle"
                    :color="bundle.id === formFields.package.id ? 'primary' : ''"
                    :dark="formFields.package.id === bundle.id"
                  >
                    <div class="text-secondary lg mb-2 text-center">{{ bundle.name }}</div>

                    <v-btn icon outlined class="package-check" small>
                      <v-icon v-if="formFields.package.id === bundle.id">mdi-check</v-icon>
                    </v-btn>

                    <div v-if="bundle.tokens_per_payment === 12" class="text-center">
                      <v-chip color="primary" class="mb-3">MOST POPULAR</v-chip>
                    </div>

                    <div :class="{ 'text-center': bundle.tokens_per_payment === 12 }">
                      <ul v-if="!bundle.lifetime" style="display: inline-block">
                        <li>
                          {{ bundle.tokens_per_payment }}
                          token{{ bundle.tokens_per_payment > 1 ? "s" : "" }} per payment
                        </li>
                        <li>{{ bundle.name }} subscription</li>
                        <li>${{ bundle.single_token_cost }} per token</li>
                      </ul>
                      <ul v-else>
                        <li>Immediate access to the 40+ current Flings</li>
                        <li>Access to all new Flings added</li>
                        <li>${{ bundle.single_token_cost }} one time payment</li>
                      </ul>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <v-expand-transition>
                <div v-show="formFields.package.id">
                  <div class="pt-10">
                    <h3 class="text-secondary lg">Order Summary</h3>

                    <div v-if="!formFields.package.lifetime" class="d-flex justify-space-between">
                      <div class="mt-2">Free Fling</div>
                      <div>"The Test Drive"</div>
                    </div>

                    <div class="d-flex justify-space-between">
                      <div v-if="!formFields.package.lifetime" class="mt-2">
                        Tokens received at end of trial
                      </div>
                      <div v-else>Tokens received today</div>
                      <div v-if="!formFields.package.lifetime">
                        {{ formFields.package.tokens_per_payment }} token{{
                          formFields.package.tokens_per_payment > 1 ? "s" : ""
                        }}
                      </div>
                      <div v-else>ALL</div>
                    </div>

                    <v-divider class="mt-5 mb-2"></v-divider>

                    <div
                      v-if="!formFields.package.lifetime"
                      class="d-flex justify-space-between title"
                    >
                      <div>Due in 21 days</div>
                      <div>
                        {{ formFields.package.name }}
                      </div>
                    </div>
                    <div v-else class="d-flex justify-space-between title">
                      <div>Due Today</div>
                      <div>${{ formFields.package.single_token_cost }}</div>
                    </div>
                  </div>

                  <div class="pt-10">
                    <h3 class="text-secondary lg">Payment Information</h3>

                    <div id="card-element" class="mt-2 pt-3" />
                    <v-alert
                      v-if="errors.card"
                      dense
                      border="left"
                      type="error"
                      class="js-form-error"
                    >
                      {{ errors.card[0] }}
                    </v-alert>
                  </div>

                  <div class="pt-4">
                    <div class="d-flex align-top" style="max-width: 300px; margin-left: auto">
                      <v-text-field
                        v-model="code"
                        label="Coupon"
                        dense
                        outlined
                        :hint="
                          codeStatus === 'good'
                            ? 'Coupon added!'
                            : codeStatus === 'bad'
                            ? 'Incorrect code'
                            : ''
                        "
                        persistent-hint
                      />
                      <v-btn
                        color="primary"
                        :disabled="code === '' || checking"
                        class="ml-2"
                        style="height: 40px"
                        @click="checkCoupon"
                      >
                        CHECK
                        <v-progress-circular
                          v-if="checking"
                          size="20"
                          width="2"
                          indeterminate
                          class="ml-2"
                        />
                      </v-btn>
                    </div>
                  </div>

                  <v-alert
                    v-if="formFields.coupon.id"
                    type="success"
                    icon="mdi-tag"
                    class="js-form-error"
                  >
                    <div class="font-weight-bold">Free Bonus Token!</div>
                    <div>
                      After completing checkout, you'll receive a Token to pick out an extra free
                      Fling!
                    </div>
                  </v-alert>
                </div>
              </v-expand-transition>

              <div class="mt-8">
                <h3 class="text-secondary lg">How did you hear about us?</h3>

                <v-select
                  v-model="formFields.how_heard"
                  :items="how_heard_options"
                  item-text="title"
                  item-value="value"
                  variant="underlined"
                />

                <v-expand-transition>
                  <div v-show="formFields.how_heard === 'other'">
                    <v-textarea
                      v-model="formFields.how_heard_other"
                      outlined
                      label="We love hearing how our members find us!"
                    />
                  </div>
                </v-expand-transition>
              </div>

              <div class="mt-5">
                <v-checkbox v-model="agree_to_terms">
                  <template v-slot:label>
                    I agree to the
                    <a
                      href="https://www.faithfulfling.com/terms-and-conditions/"
                      target="_blank"
                      @click.stop=""
                      class="ml-1"
                    >
                      Terms & Conditions </a
                    >.
                  </template>
                </v-checkbox>
              </div>

              <div class="text-right mt-5">
                <v-btn
                  color="primary"
                  :disabled="(!valid && !submitted) || submitting || !agree_to_terms"
                  class="mt-2"
                  @click.prevent="submit"
                >
                  submit
                  <v-progress-circular
                    v-if="submitting"
                    size="20"
                    width="2"
                    indeterminate
                    class="ml-2"
                  />
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Stripe from "@/mixins/Stripe.vue";

export default {
  name: "LoginView",
  mixins: [Stripe],
  data() {
    return {
      valid: false,
      submitting: false,
      submitted: false,
      errors: {},
      packages: [],

      formFields: {
        first_name: "",
        last_name: "",
        email: "",
        role: "",
        spouse_first_name: "",
        spouse_last_name: "",
        spouse_email: "",
        package: {},
        how_heard: "",
        how_heard_other: "",
        coupon: {},
      },
      agree_to_terms: false,

      // Test data
      // formFields: {
      //   first_name: "Shane",
      //   last_name: "Taylor",
      //   email: `shane+${Math.floor(Math.random() * 1000)}@velocitywebworks.com`,
      //   role: "husband",
      //   spouse_first_name: "Wife",
      //   spouse_last_name: "Taylor",
      //   spouse_email: `shane+${Math.floor(Math.random() * 1000)}@velocitywebworks.com`,
      //   package: {},
      //   how_heard: "",
      //   how_heard_other: "",
      //   coupon: {},
      // },
      // agree_to_terms: true,

      firstNameRules: [
        (v) => !!v || "First name is required",
        (v) => (v && v.length <= 30) || "First name must be no more than 30 characters",
      ],
      lastNameRules: [
        (v) => !!v || "Last name is required",
        (v) => (v && v.length <= 50) || "Last name must be no more than 50 characters",
      ],
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      spouseEmailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
        (v) => v.trim() !== this.formFields.email.trim() || "Email cannot be the same as spouse",
      ],
      roleRules: [(v) => !!v || "Role is required"],

      how_heard_options: [
        { title: "Podcast", value: "podcast" },
        { title: "Search engine (Google, Yahoo, etc.)", value: "search_engine" },
        { title: "Friend or word of mouth", value: "friend" },
        { title: "Instagram", value: "instagram" },
        { title: "Facebook", value: "facebook" },
        { title: "Blog post or article", value: "blog" },
        { title: "Other, please tell us!", value: "other" },
      ],

      code: "",
      checking: false,
      codeStatus: "",
    };
  },

  computed: {
    activePackages() {
      return this.packages.filter((pack) => pack.active);
    },

    spouseTitle() {
      if (this.formFields.role === "husband") {
        return "Wife's";
      }
      return "Husband's";
    },

    packageCost() {
      let cost = "";
      if (this.formFields.package === "twelve_monthly") {
        cost = "9.99";
      } else if (this.formFields.package === "twelve_annually") {
        cost = "99.00";
      } else if (this.formFields.package === "six_monthly") {
        cost = "14.99";
      } else if (this.formFields.package === "six_annually") {
        cost = "75.00";
      }
      return cost;
    },

    packageName() {
      let name = "";
      if (this.formFields.package === "twelve_monthly") {
        name = "12 Flings / Year (billed monthly)";
      } else if (this.formFields.package === "twelve_annually") {
        name = "12 Flings / Year (billed annually)";
      } else if (this.formFields.package === "six_monthly") {
        name = "6 Flings / Year (billed bi-monthly)";
      } else if (this.formFields.package === "six_annually") {
        name = "6 Flings / Year (billed annually)";
      }
      return name;
    },

    dueIn21Days() {
      let due = 0;

      if (this.packageCost) {
        due += Number(this.packageCost);
      }

      return due.toFixed(2);
    },
  },

  async created() {
    this.packages = await this.load_packages();
  },

  methods: {
    async submit() {
      // Reset submission status
      this.errors = {};
      this.submitting = true;
      this.submitted = true;

      // Create Stripe token for the credit card
      const result = await this.stripe.createToken(this.card);
      if (result.error) {
        this.submitting = false;
        this.errors.card = [result.error.message];
        return;
      }

      // Create postData and set it up for the API call
      const postData = JSON.parse(JSON.stringify(this.formFields));
      postData.new_package = postData.package.id;
      postData.token = result.token.id;
      if (postData.coupon.id) {
        postData.coupon_id = postData.coupon.id;
      }

      // Get Afid cookie and add it to the params
      const afid = this.getCookie("faithfulflingAfid");

      const responseData = await this.api({
        url: "users/",
        method: "POST",
        json: postData,
        params: { afid },
      });

      this.submitting = false;

      if (responseData.status === 201) {
        this.$router.push({ name: "success" });
      } else if (responseData.status === 400) {
        this.errors = responseData.body;
        this.$nextTick(() => {
          this.scrollToFirstError(this.$refs.signUpForm.$el);
        });
      } else {
        this.errors = {
          non_field_errors: [
            "Unable to communicate with the server. Please check your " +
              "connection and try again.",
          ],
        };
        this.$nextTick(() => {
          this.scrollToFirstError(this.$refs.signUpForm.$el);
        });
      }
    },

    async checkCoupon() {
      this.checking = true;
      this.codeStatus = "";

      const responseData = await this.api({
        url: `coupons/check_code/?code=${this.code}`,
      });

      this.checking = false;

      if (responseData.status === 200) {
        this.code = "";
        this.formFields.coupon = responseData.body;
        this.codeStatus = "good";
      } else {
        this.code = "";
        this.codeStatus = "bad";
      }
    },

    getCookie(cname) {
      const name = `${cname}=`;
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.package-card {
  position: relative;

  .package-check {
    position: absolute;
    top: 15px;
    right: 15px;
  }

  li {
    text-align: left;
  }
}
</style>
